import { ThumbsDown, ThumbsUp } from "lucide-react";
import { useState } from "react";
import feedbackService from "../services/feedbackService";
import { FeedbackModal } from "./common/ui/FeedbackModal";
import { getMessageActionClassName, MESSAGE_ACTION_STYLES } from "../utils/messageActionStyles";

const ThumsUpDown = ({ dialogId }) => {
  const [likeDislike, setLikeDislike] = useState(null);
  const [feedbackModal, setFeedbackModal] = useState(false);

  const sendFeedback = async (dialogFeedback) => {
    if (!likeDislike) return;

    const feedback_body = {
      reaction_emoji: likeDislike,
      dialog_id: dialogId,
      dialog_feedback:dialogFeedback
    };
    console.log(feedback_body);
    

    try {
      const data = await feedbackService.feedback(feedback_body);
      console.log("Feedback response:", data);
    } catch (error) {
      console.error("Error sending feedback:", error);
    }
    setFeedbackModal(false)
  };
  

  const handleLike = () => {
    if (!likeDislike) {
      setLikeDislike("like");
      setFeedbackModal(true);
    }
  };

  const handleDisLike = () => {
    if (!likeDislike) {
      setLikeDislike("dislike");
      setFeedbackModal(true);
    }
  };

  const handleClose = () => {
    setFeedbackModal(false);
  };

  return (
    <div className="flex gap-2">
      <button
        className={getMessageActionClassName('like', likeDislike === "like", likeDislike !== null && likeDislike !== "like")}
        title="Like"
        onClick={handleLike}
        disabled={likeDislike !== null}
      >
        <ThumbsUp size={MESSAGE_ACTION_STYLES.ICON_SIZE} className={likeDislike === "like" ? MESSAGE_ACTION_STYLES.COLORS.LIKE.ACTIVE : MESSAGE_ACTION_STYLES.COLORS.LIKE.DEFAULT} />
      </button>
      <button
        className={getMessageActionClassName('dislike', likeDislike === "dislike", likeDislike !== null && likeDislike !== "dislike")}
        title="Dislike"
        onClick={handleDisLike}
        disabled={likeDislike !== null}
      >
        <ThumbsDown size={MESSAGE_ACTION_STYLES.ICON_SIZE} className={likeDislike === "dislike" ? MESSAGE_ACTION_STYLES.COLORS.DISLIKE.ACTIVE : MESSAGE_ACTION_STYLES.COLORS.DISLIKE.DEFAULT} />
      </button>
      {feedbackModal && (
        <FeedbackModal
          isOpen={feedbackModal}
          onConfirm={sendFeedback}
          onCancel={handleClose}
        />
      )}
    </div>
  );
};

export default ThumsUpDown;
